import { CartResponse } from '@models/cart';
import { CreateOrderRequest, OrderLine } from '@models/order';
import { ProjectPgVendor } from '@models/project';
import { ShopResponse } from '@models/shop';
import orderWithTotalAmount from '@providers/OrderProvider/utils/orderWithTotalAmount';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';
import getGlobalName from '@utils/getGlobalName';

import { initialState } from '../../constants';

export interface PrepareWithCartParams {
    cart: CartResponse,
    shop: ShopResponse,
}

export function prepareWithCart(state: WritableDraft<CreateOrderRequest>, payload: PayloadAction<PrepareWithCartParams>) {
    const { cart, shop } = payload.payload;
    const orderLines: OrderLine[] = cart.items
        .map((cartItem) => ({
            status: cartItem.status,
            shopItemId: cartItem.itemId,
            itemName: cartItem.name,
            thumbnailImage: cartItem.thumbnailUrl,
            itemPrice: cartItem.salePrice,
            quantity: cartItem.qty,
            totalAmount: cartItem.salePrice * cartItem.qty,
            cartItemId: cartItem.cartItemId,
            itemImageUrl: cartItem.thumbnailUrl,
            couponUsable: cartItem.couponUsable,
            personalOptions: [],
            posId: cartItem.posId,
            defaultOptions: [{
                optionGroupId: '',
                maxSelection: 10,
                minSelection: 0,
                options: cartItem.options.map((cartOption) => ({
                    shopOptionId: cartOption.optionId,
                    optionName: cartOption.name,
                    optionPrice: cartOption.salePrice,
                    quantity: cartOption.qty,
                    totalAmount: cartOption.qty * cartOption.salePrice * cartItem.qty,
                    maxQuantity: 10,
                    posId: cartOption.posId,
                })),
            }],
        }));

    const defaultValue: CreateOrderRequest = orderWithTotalAmount({
        projectId: '',
        shopId: shop.id,
        shopName: shop.name,
        cartId: cart.cartId,
        orderPath: 'CART',
        orderType: 'TAKE_OUT',
        orderLines,
        totalAmount: 0,
        paymentMethod: 'CREDIT_CARD',
        paymentAmount: 0,
        totalDiscount: 0,
        totalPointDiscount: 0,
        totalGiftDiscount: 0,
        totalCouponDiscount: 0,
        returnUrl: `${import.meta.env.VITE_BASE_URL}/purchase/complete`,
    });
    Object.assign(state, defaultValue);
}

export function resetCart(state: WritableDraft<CreateOrderRequest>, action: PayloadAction<ShopResponse>) {
    const { name, id } = action.payload;
    Object.assign(state, {
        ...initialState,
        shopName: name,
        shopId: id,
    });
}
